import request from '../untils/request';

export function selectRole() {
	return request({
		url: '/comboboxLoad/selectRole',
		method: 'get',
	});
}

export function selectParentMeter() {
	return request({
		url: '/comboboxLoad/selectParentMeter',
		method: 'get',
	});
}

// 电表下拉列表
export function selectMeter() {
	return request({
		url: '/comboboxLoad/selectMeter',
		method: 'get',
	});
}
// 水表下拉列表
export function selectWaterMeter() {
	return request({
		url: '/comboboxLoad/selectWaterMeter',
		method: 'get',
	});
}

// 商户下拉列表
export function selectLessee() {
	return request({
		url: '/comboboxLoad/selectLessee',
		method: 'get',
	});
}
// 未销户 商户下拉列表
export function selectValidLessee() {
	return request({
		url: '/comboboxLoad/selectValidLessee',
		method: 'get',
	});
}
// 字典
export function selectDictionaryListByName(param) {
	return request({
		url: '/comboboxLoad/selectDictionaryListByName',
		method: 'get',
		params: {
			name: param
		},
	});
}
// 前置字典下拉列表
export function selectDictionaryFrontListByName(param) {
	return request({
		url: '/comboboxLoad/selectDictionaryFrontListByName',
		method: 'get',
		params: {
			name: param
		},
	});
}

export function selectAlarmConfigCommonList() {
	return request({
		url: '/comboboxLoad/selectAlarmConfigCommonList',
		method: 'get',
	});
}

// 终端类型
export function selectMeterTerminalList() {
	return request({
		url: '/comboboxLoad/selectMeterTerminalList',
		method: 'get',
	});
}
// 水表终端类型
export function selectWaterTerminalList() {
	return request({
		url: '/comboboxLoad/selectWaterTerminalList',
		method: 'get',
	});
}

// 获取未绑定电表下拉列表数据
export function selectUnUseMeter() {
	return request({
		url: '/comboboxLoad/selectUnUseMeter',
		method: 'get',
	});
}
// 获取未绑定水表下拉列表数据
export function selectUnUseWaterMeter() {
	return request({
		url: '/comboboxLoad/selectUnUseWaterMeter',
		method: 'get',
	});
}

// 获取 电表厂商 下拉列表数据
export function selectMeterProducerList() {
	return request({
		url: '/comboboxLoad/selectMeterProducerList',
		method: 'get',
	});
}
// 获取 水表厂商 下拉列表数据
export function selectWaterProducerList() {
	return request({
		url: '/comboboxLoad/selectWaterProducerList',
		method: 'get',
	});
}
// 区域下拉列表
export function selectSensorDistrict() {
	return request({
		url: '/comboboxLoad/selectSensorDistrict',
		method: 'get',
	});
}
// 区域链级下拉框
export function selectComboboxTreeData() {
	return request({
		url: '/sensorDistrict/selectComboboxTreeData',
		method: 'get',
	});
}
